export default function AudioPreview({ src }) {
    return (
      <audio
        src={src}
        controls
        style={{ width: "100%" }}
      />
    );
  }